module.exports = __webpack_public_path__ + "1455661b98dc884046f2d5845effd181.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/mask-feathers-s.png
// module id = 2469
// module chunks = 0